import React, {useCallback, useState, useEffect, useRef} from 'react';
import {MotifToast} from '../MotifWrapperComponents/motifCompat';
import {Subject} from 'rxjs';
import styled from 'styled-components';

const toastSubject = new Subject({
	variant: 'success',
	actionName: '',
	position: 'top',
	duration: 3000,
	children: 'Toast message',
	area: 'toastArea'
});

const toastObservable = toastSubject.asObservable();

const toastResponseSubject = new Subject({
	event: null
});

const toastResponse = toastResponseSubject.asObservable();

function Toast({area = 'toastArea'}) {
	const [showToast, setShowToast] = useState(false);
	const [toastProps, setToastProps] = useState({});

	const subscriptionRef = useRef(null);

	useEffect(() => {
		subscriptionRef.current = toastObservable.subscribe({
			next: (args) => {
				if (area === args.area) {
					setShowToast(true);
					setToastProps(args);
				}
			}
		});

		return () => {
			if (subscriptionRef.current !== null) {
				subscriptionRef.current.unsubscribe();
			}
		};
	}, []);

	const actionOnClick = useCallback((event) => {
		toastResponseSubject.next({type: 'action', event});
	}, []);

	const onClose = useCallback((event) => {
		setShowToast(false);
		setToastProps({});
		toastResponseSubject.next({type: 'close', event});
	}, []);

	useEffect(() => {
		if (toastProps.duration > 0) {
			const timer = setTimeout(() => {
				setShowToast(false);
			}, toastProps.duration);

			return () => clearTimeout(timer);
		}
	}, [toastProps]);

	return (
		showToast && (
			<StyledToast className={`StyledToast ${toastProps.className}`}>
				<MotifToast {...toastProps} actionOnClick={actionOnClick} onClose={onClose}>
					<section className="message">{toastProps.children}</section>
				</MotifToast>
			</StyledToast>
		)
	);
}

const StyledToast = styled.section`
	.motif-toast {
		z-index: 1;
		&.motif-toast-fixed-top {
			top: var(--px-63);
			width: 96%;
			position: fixed;
			right: 0;
			left: 2%;
			&.independenceSuccessMessage,
			&.independenceFailureMessage {
				left: var(--px-170);
				width: calc(100% - var(--px-220));
			}
		}
	}
`;

function toggleToast(props) {
	toastSubject.next(props);
}

export {toastResponse, toggleToast};
export default Toast;
